<ng-container *ngIf="showTitle">
  <basic-label></basic-label>
</ng-container>
<div class="radio-group" [ngClass]="modifierClasses" id="{{ componentId }}">
  <div *ngFor="let option of options; let i = index" class="radio-button">
    <input
      class="radio-button__input"
      type="radio"
      id="{{ radioGroupName }}-choice-{{ i }}"
      name="{{ radioGroupName }}"
      [attr.name]="radioGroupName"
      [(ngModel)]="selectedItem"
      value="{{ option.value }}"
      (change)="trigger()"
    />

    <label class="radio-button__label" for="{{ radioGroupName }}-choice-{{ i }}">
      <div class="radio-button__description">{{ option.description }}</div>
    </label>
  </div>
  <p class="error-message error-message--entry-field" *ngIf="isError">{{ errorMessage[prop] }}</p>
</div>
